import * as echarts from "echarts";
import moment from "moment";
import "moment-timezone";
var randomColor = require('randomcolor');
// import router from '../router/index.js'
import { EleResize } from './a.js'
import i18n from "@/i18n";
import { AUDITING_MEASUREMENT_UNIT_MAP, IS_DEMO_PAPER_MAKING_EP1000_ID } from "../config/common.js"
import { findYAxisMinMax } from "./common.js";

/* 获取区间 */ 
const getIntervals = (data, numIntervals) => {
    // 获取最大值和最小值
    data =
      (data && data.filter((item) => item !== null && item !== undefined)) || [];
    if (data && data.length > 0) {
      data.filter((item) => !item);
      const max = Math.ceil(Math.max(...data)) * 1.2;
      const min =
        Math.floor(Math.min(...data)) > 0 ? 0 : Math.floor(Math.min(...data));
  
      // 计算区间
      const range = max - min;
      const interval = Math.ceil(range / numIntervals);
  
      // 存储结果
      const intervals = [];
  
      for (let i = 0; i <= numIntervals; i++) {
        // 计算每个分割点，并取整
        const value = Math.ceil(min + i * interval);
        intervals.push(value);
      }
      if (min + max === 0) {
        return {
          min: 0,
          max: 5,
          intervals: [0, 1, 2, 3, 4, 5],
        };
      } else {
        return {
          min,
          max,
          intervals,
        };
      }
    } else {
      return {
        min: 0,
        max: 0,
        intervals: [],
      };
    }
  };

/* 图谱分析页面 */
const spectrumEcharts = (options, flag) => {
    let { chartDom, dataList } = options;
    
    let title = options.title || {}
    //添加参数 增加放大清晰度。renderer: 'svg'
    echarts.init(chartDom ,null, {renderer: 'svg'}).dispose() 
    let myChart = echarts.getInstanceByDom(chartDom)
    let color = [
        "rgba(102, 145, 231,.7)",
        "rgba(134, 92, 226,.7)",
        "rgba(80, 195, 230,.7)",
        "rgba(236, 156, 98,.7)",
        "rgba(60, 146, 173,.7)",
        "rgba(50, 246, 173,.7)",
    ];
    let yAxis = [];
    if (myChart == null || myChart == "") {
        myChart = echarts.init(chartDom);
    } 
    let legendList = [];


    if (dataList && dataList.length) {
        dataList.map((data, index) => {
            legendList.push(data.name);
            if (data.areaStyle) {
                return;
            }
            data.step =data.dtype&&data.dtype=="number"?'end':false;
            let newArr = []
            data.data.map(item => {
                item.name = new Date(item.name).toString()
                if(item.value&&(item.value[1]||item.value[1]==0)&&item.value[1] !== ''&&item.value[1] !== '-'){
                    newArr.push(item.value[1])
                  }
            })

            data.yAxisIndex = index
            var offsets = [0, 30, 60, 0, 30, 60]
            let yaxis = {
                position: index <= 2 ? "left" : "right",
                offset: offsets[index],
                // boundaryGap: ["20%", "50%"],
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: color[index],
                    },
                },
                type: "value",
                name: data.unit,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    lineStyle: {
                        color: color[index],
                    },
                    show: true,
                    onZero: true,
                },
            }

            //找出最大值最小值
            let minMax = findYAxisMinMax(newArr)
            // console.log(minMax);
            if(minMax){
                yaxis[minMax.key] = minMax.value
            }

            yAxis.push(yaxis);
        });
    } else {
        yAxis.push({
            type: "value",
            name: "",
            // boundaryGap: ["20%", "50%"],
            axisTick: {
                show: true,
            },
            axisLine: {
                show: true,
                onZero: true,
                lineStyle: {
                    color: "rgba(0,0,0)",
                },
            },
            splitLine: {
                show: true,
                lineStyle: {
                    //y轴分隔线样式设置
                    color: "#F3F6F9A1", //颜色
                    type: "solid", //虚线
                },
            },
        });
    }


    var dataZoomS = 0
    var dataZoomE = 100
    if (JSON.parse(localStorage.getItem('dataZoom'))) {
        dataZoomS = JSON.parse(localStorage.getItem('dataZoom')).start
        dataZoomE = JSON.parse(localStorage.getItem('dataZoom')).end
    }
    let option = {
        title: {
            text: title,
            show: false,
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "cross",
                axis: "x",
                animation: false,
            },
            formatter: function (params) {
                let returnData = "";
                for (let i = 0; i < params.length; i++) {
                    if (params[i].seriesName != "") {
                        let indexColor = params[i].color;
                        if (params[i].seriesName == "动态阈值") {
                            params[i].seriesName = "动态阈值（高）";
                            params[i + 1].seriesName = "动态阈值（低）";
                        }
                        returnData +=
                            '<div style="margin-top:10px;">' +
                            '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:' +
                            indexColor +
                            '"></span>' +
                            '<span style="display:inline-block;margin-right:10px">' +
                            params[i].seriesName +
                            ":" +
                            "</span>" +
                            params[i].value[1] +
                            "</div>";
                    }
                }
                return (
                    "<div>" +
                    moment(params[0].value[0])
                        .tz(localStorage.getItem("tz") || "Asia/Shanghai")
                        .format("YYYY-MM-DD HH:mm:ss.SSS") +
                    "</div>" +
                    returnData
                );
            },
        },
        legend: {
            data: legendList,
            show: true,
            top: 0,
        },
        grid: {
            top: 90,
        },
        xAxis: [
            {
                type: "time",
                splitNumber: 5,
                splitLine: {
                    show: false,
                    lineStyle: {
                        //y轴分隔线样式设置
                        color: "#F3F6F97", //颜色
                        type: "solid", //虚线
                    },
                },
                axisTick: {
                    show: true,
                },
                position: "bottom",
                axisLine: {
                    show: true,
                    onZeroAxisIndex: "-20",
                },
                // axisLabel: {
                //     showMaxLabel: true, //强制显示最后一个数据的刻度
                //     showMinLabel: true, //强制显示第一个数据的刻度
                //     formatter: function (params) {
                //         return moment(params).tz(localStorage.getItem('tz') || 'Asia/Shanghai').format("YYYY/MM/DD HH:mm:ss")
                //     },
                // },
            },
        ],
        yAxis: yAxis,
        color,
        dataZoom: [
            {
                show: true,
                type: "slider",
                start: dataZoomS,
                end: dataZoomE,
                minValueSpan: 1000,
                labelFormatter: function (value) {
                    return moment(value)
                        .tz(localStorage.getItem("tz") || "Asia/Shanghai")
                        .format("YYYY-MM-DD HH:mm:ss");
                },
            },
        ],
        triggerEvent: true,
        series: dataList,
    };
    setTimeout(() => {
        /* document
            .getElementById("monitor")
            .setAttribute("_echarts_instance_", ""); */
        myChart.clear()
        myChart && option && myChart.setOption(option, true)
        myChart && myChart.hideLoading();
    }, 1000)

    if (flag) {
        //判断是是否要添加注释图表
        // myChart && option && myChart.setOption(option, true)
        return;
    }
    myChart.on("datazoom", function (param) {
        localStorage.setItem("dataZoom", JSON.stringify(param));
        option.dataZoom.map((item) => {
            item.start = param.start;
            item.end = param.end;
        });
    });
    myChart.on("click", (param) => {
        //这里根据param填写你的跳转逻辑
        if (param.name == '注释') {
            localStorage.setItem('valueAnnotation', JSON.stringify({ data: param.data.coord, type: 'annotation', offsetX: param.event.offsetX, offsetY: param.event.offsetY }))
        }
        option.series.map(item => {
            item.markPoint.data = item.markPoint.data.filter(item => {
                return item.name == '注释'
            })
            if (item.name == param.seriesName) {
                localStorage.setItem(
                    "valueAnnotation",
                    JSON.stringify({
                        shadowId: param.value[2],
                        name: param.seriesName,
                        data: param.value,
                        type: "chooseSeries",
                    })
                );
                item.markPoint.data.push({
                    name: "chooseSeries",
                    value: param.value[1],
                    xAxis: param.value[0],
                    yAxis: param.value[1],
                    itemStyle: {
                        zIndex: 999,
                    },
                });
            }
        });
        /* document
        .getElementById("monitor")
        .setAttribute("_echarts_instance_", ""); */

        // myChart.setOption(option, true)
        // myChart && echarts.init(chartDom).resize();
    });

    // 将可以响应点击事件的范围内，鼠标样式设为pointer--------------------
    myChart.getZr().on("mousemove", function (params) {
        const { topTarget } = params;
        // 给折线的鼠标悬浮 变为 小手
        if (topTarget?.z === 2) {
            myChart.getZr().setCursorStyle("pointer");
        }
    });
    /*  myChart && option && myChart.setOption(option, true)
       myChart.hideLoading() */
    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)
};
/* 健康监控页面 */
const spectrumEcharts1 = (options,flag) => {
    let { chartDom, dataList, dataZoom } = options;
    dataZoom.map((item) => {
        (item["show"] = true), (item["type"] = "slider");
    });
    let title = options.title || {
        text: i18n.global.t('page.Real-Time Data Chart'),
        textStyle: { fontSize: 12 },
    };
    let color = [
        "rgba(102, 145, 231)",
        "rgba(134, 92, 226)",
        "rgba(80, 195, 230)",
        "rgba(236, 156, 98)",
        "rgba(60, 146, 173)",
    ];
    let yAxis = [];
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart == null || myChart == "") {
        myChart = echarts.init(chartDom);
    }
    if (dataList && dataList.length) {
        dataList.map((data, index) => {
            let newArr = []
            data.data.map(item => {
                if(item.value&&(item.value[1]||item.value[1]==0)&&item.value[1]){
                    newArr.push(item.value[1])
                  }
            })
            let yaxis = {
                position: "left",
                offset: index * 30,
                boundaryGap: ["20%", "50%"],
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: color[index] || "#000",
                    },
                },
                type: "value",
                name: data.unit,
                axisTick: {
                    show: true,
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        //y轴分隔线样式设置
                        color: "#F3F6F9A1", //颜色
                        type: "solid", //虚线
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: color[index] || "#000",
                    },
                    show: true,
                    onZero: true,
                },
            }
            //找出最大值最小值
            let minMax = findYAxisMinMax(newArr)
            // console.log(minMax);
            if(minMax){
                yaxis[minMax.key] = minMax.value
            }
            yAxis.push(yaxis);
        });
    }
    let option = {
        title,
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "cross",
                animation: false,
            },
            formatter: function (params) {
                let returnData = "";
                for (let i = 0; i < params.length; i++) {
                    if (params[i].seriesName != "") {
                        let indexColor = params[i].color;
                        returnData +=
                            '<div style="margin-top:10px;">' +
                            '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:' +
                            indexColor +
                            '"></span>' +
                            '<span style="display:inline-block;margin-right:10px">' +
                            params[i].seriesName +
                            ":" +
                            "</span>" +
                            params[i].value[1] +
                            "</div>";
                    }
                }
                return (
                    "<div>" +
                    moment(params[0].value[0])
                        .tz(localStorage.getItem("tz") || "Asia/Shanghai")
                        .format("YYYY-MM-DD HH:mm:ss.SSS") +
                    "</div>" +
                    returnData
                );
            },
        },
        xAxis: [
            {
                type: "time",
                splitLine: {
                    show: false,
                },
            },
        ],
        yAxis: yAxis,
        color: [
            "rgb(102, 145, 231)",
            "rgb(134, 92, 226)",
            "rgb(80, 195, 230)",
            "rgb(236, 156, 98)",
            "rgb(60, 146, 173)",
            "rgb(30, 33, 37)",
        ],
        dataZoom,
        triggerEvent: true,
        series: dataList,
    };

    if(flag){
        myChart && option && myChart.setOption({series: option.series})
    }else{
        myChart && option && myChart.setOption(option,true)
        myChart && myChart.hideLoading();
   
    }
    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)
};
/* 事件管理页面 */
const spectrumEcharts2 = (options) => {
    let { chartDom, dataList } = options;
    let title = options.title || {};
    let myChart = echarts.getInstanceByDom(chartDom);
    let color = [
        "rgba(102, 145, 231)",
        "rgba(134, 92, 226)",
        "rgba(80, 195, 230)",
        "rgba(236, 156, 98)",
        "rgba(60, 146, 173)",
    ];
    let yAxis = [
        {
            type: "value",
            name: "",
            boundaryGap: ["20%", "50%"],

            axisTick: {
                show: true,
            },
            axisLine: {
                show: true,
                onZero: true,
                lineStyle: {
                    color: "rgba(102, 145, 231)",
                },
            },
            splitLine: {
                show: true,
                lineStyle: {
                    //y轴分隔线样式设置
                    color: "#F3F6F9A1", //颜色
                    type: "solid", //虚线
                },
            },
        },
    ];
    if (myChart == null || myChart == "") {
        myChart = echarts.init(chartDom);
        myChart &&
            myChart.showLoading({
                text: "加载中...",
                color: "#6691e7",
                textColor: "#000",
                maskColor: "rgba(255, 255, 255, 0.8)",
                zlevel: 0,
            });
    }
    if (dataList && dataList.length) {
        dataList.map((data, index) => {
            if (data.areaStyle) {
                return;
            }
            data.yAxisIndex = index;
            yAxis.push({
                position: "left",
                offset: index * 30,
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: color[index],
                    },
                },
                type: "value",
                name: data.unit,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    lineStyle: {
                        color: color[index],
                    },
                    show: true,
                    onZero: true,
                },
            });
        });
    }
    let dataZoom = [
        {
            show: true,
            type: "slider",
            start: 0,
            end: 100,
            minValueSpan: 1000,
            labelFormatter: function (value) {
                return moment(value)
                    .tz(localStorage.getItem("tz") || "Asia/Shanghai")
                    .format("YYYY-MM-DD HH:mm:ss");
            },
        },
    ];
    let option = {
        title,
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "cross",
                animation: false,
            },
            formatter: function (params) {
                let returnData = "";
                for (let i = 0; i < params.length; i++) {
                    if (params[i].seriesName != "") {
                        let indexColor = params[i].color;
                        returnData +=
                            '<div style="margin-top:10px;">' +
                            '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:' +
                            indexColor +
                            '"></span>' +
                            '<span style="display:inline-block;margin-right:10px">' +
                            params[i].seriesName +
                            ":" +
                            "</span>" +
                            params[i].value[1] +
                            "</div>";
                    }
                }
                return (
                    "<div>" +
                    moment(params[0].value[0])
                        .tz(localStorage.getItem("tz") || "Asia/Shanghai")
                        .format("YYYY-MM-DD HH:mm:ss.SSS") +
                    "</div>" +
                    returnData
                );
            },
        },
        xAxis: [
            {
                type: "time",
                // splitNumber: 5,
                splitLine: {
                    show: true,
                    lineStyle: {
                        //y轴分隔线样式设置
                        color: "#C5C5C5", //颜色
                        type: "solid", //虚线
                    },
                },
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                },
                axisLabel: {
                    showMaxLabel: true, //强制显示最后一个数据的刻度
                    showMinLabel: true, //强制显示第一个数据的刻度
                    formatter: function (params) {
                        return moment(params)
                            .tz(localStorage.getItem("tz") || "Asia/Shanghai")
                            .format("HH:mm:ss");
                    },
                },
                axisPointer: {
                    label: {
                        formatter: function (params) {
                            return moment(params.value)
                                .tz(localStorage.getItem("tz") || "Asia/Shanghai")
                                .format("YYYY-MM-DD HH:mm:ss");
                        },
                    },
                },
            },
        ],
        yAxis: yAxis,
        color,
        dataZoom,
        triggerEvent: true,
        series: dataList,
    };
    setTimeout(() => {
        /* document
            .getElementById("monitor")
            .setAttribute("_echarts_instance_", ""); */
        myChart && option && myChart.clear()
        myChart && option && myChart.setOption(option, true)
        // myChart && echarts.init(chartDom).resize();
        myChart && myChart.hideLoading();
    }, 1000)
    window.addEventListener("resize", () => { myChart.resize(); });
}

/* 智能分析页面 */ 
let myChartR = null
const spectrumEcharts3 = (options, flag) => {
  let { chartDom, dataLists } = options;
  let dataList = Array.isArray(dataLists)
    ? dataLists.filter((item) => item && item.is_checked)
    : [];

  if(flag){/* flag 用于只更新数据 */
    if (!myChartR) return;
    updatedSeriesF(dataList)
    return;
  }else{
    let title = options.title || {};
    echarts.init(chartDom).dispose();
    myChartR = echarts.getInstanceByDom(chartDom);
    let color = [
      "rgba(34, 187, 232, 1)",
      "rgb(48, 61, 255)",
      "rgba(252, 190, 92, 0.7)",
      "rgba(134, 92, 226,.7)",
      "rgba(60, 146, 173,.7)",
      "rgba(50, 246, 173,.7)",
    ];
    let yAxis = [];
    if (myChartR == null || myChartR == "") {
      myChartR = echarts.init(chartDom);
    }
    let legendList = [];
  
    if (dataList && dataList.length) {
      dataList.map((data, index) => {
        legendList.push(data.name);
        if (data.areaStyle) {
          return;
        }
        data.step = data.dtype && data.dtype == "number" ? "end" : false;
        let newArr = [];
        data.data.map((item) => {
          item.name = new Date(item.name).toString();
          if (
            item.value &&
            (item.value[1] || item.value[1] == 0) &&
            item.value[1]
          ) {
            newArr.push(item.value[1]);
          }
        });
  
        data.yAxisIndex = index;
        var offsets = [0, 0, 30, 30, 60, 60];
        let yaxis = {
          position: ((index+1)%2) == 0 ? "right" : "left",
          offset: offsets[index],
          // boundaryGap: ["20%", "50%"],
          axisLabel: {
            show: true,
            textStyle: {
              color: color[index],
            },
          },
          type: "value",
          name: data.unit,
          axisTick: {
            show: false,
          },
          splitNumber:4,
          axisLine: {
            lineStyle: {
              color: color[index],
            },
            show: false,
            onZero: true,
          },
        };
  
        //找出最大值最小值
        let minMax = findYAxisMinMax(newArr);
        // console.log(minMax);
        if (minMax) {
          yaxis[minMax.key] = minMax.value;
        }
  
        yAxis.push(yaxis);
      });
    } else {
      yAxis.push({
        type: "value",
        name: "",
        // boundaryGap: ["20%", "50%"],
        axisTick: {
          show: true,
        },
        axisLine: {
          show: true,
          onZero: true,
          lineStyle: {
            color: "rgba(0,0,0)",
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            //y轴分隔线样式设置
            color: "#F3F6F9A1", //颜色
            type: "solid", //虚线
          },
        },
      });
    }
    let option = {
      title: {
        text: title,
        show: false,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          axis: "x",
          animation: false,
        },
        formatter: function (params) {
          let returnData = "";
          for (let i = 0; i < params.length; i++) {
            if (params[i].seriesName != "") {
              let indexColor = params[i].color;
              if (params[i].seriesName == "动态阈值") {
                params[i].seriesName = "动态阈值（高）";
                params[i + 1].seriesName = "动态阈值（低）";
              }
              returnData +=
                '<div style="margin-top:10px;">' +
                '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:' +
                indexColor +
                '"></span>' +
                '<span style="display:inline-block;margin-right:10px">' +
                params[i].seriesName +
                ":" +
                "</span>" +
                params[i].value[1] +
                "</div>";
            }
          }
          return (
            "<div>" +
            moment(params[0].value[0])
              .tz(localStorage.getItem("tz") || "Asia/Shanghai")
              .format("YYYY-MM-DD HH:mm:ss.SSS") +
            "</div>" +
            returnData
          );
        },
      },
      legend: {
        data: legendList,
        show: true,
        bottom: 0,
        itemGap: 10,
        itemWidth: 10,
        itemHeight: 10,
        icon: 'rect',
        textStyle: {
           color: '#fff',
           fontSize: 12,
           rich: {
              a: {
                 verticalAlign: 'middle'
              }
           },
           padding: [0, 0, -2, 0]
        }
      },
      grid: {
        top:50,
        left:38,
        right:38,
        bottom:50,
      },
      xAxis: [
        {
          type: "category",
          splitNumber: 5,
          // boundaryGap:false,
          splitLine: {
            show: false,
            lineStyle: {
              //y轴分隔线样式设置
              color: "#F3F6F97", //颜色
              type: "solid", //虚线
            },
          },
          axisTick: {
            show: false,
          },
          position: "bottom",
          axisLine: {
            show: true,
            onZeroAxisIndex: "-20",
          },
          axisLabel: {
            show:false
          //     showMaxLabel: true, //强制显示最后一个数据的刻度
          //     showMinLabel: true, //强制显示第一个数据的刻度
          //     formatter: function (params) {
          //         return moment(params).tz(localStorage.getItem('tz') || 'Asia/Shanghai').format("YYYY/MM/DD HH:mm:ss")
              },
          // },
        },
      ],
      yAxis: yAxis,
      color,
      triggerEvent: true,
      series: dataList,
    };
    setTimeout(() => {
      /* document
              .getElementById("monitor")
              .setAttribute("_echarts_instance_", ""); */
              myChartR.clear();
              myChartR && option && myChartR.setOption(option);
              myChartR && myChartR.hideLoading();
    }, 500);
  
    myChartR.off("click");
    myChartR.on("click", (param) => {
      //这里根据param填写你的跳转逻辑
      if (param.name == "注释") {
        localStorage.setItem(
          "valueAnnotation",
          JSON.stringify({
            data: param.data.coord,
            type: "annotation",
            offsetX: param.event.offsetX,
            offsetY: param.event.offsetY,
          })
        );
      }
      option.series.map((item) => {
        item.markPoint.data = item.markPoint.data.filter((item) => {
          return item.name == "注释";
        });
        if (item.name == param.seriesName) {
          localStorage.setItem(
            "valueAnnotation",
            JSON.stringify({
              shadowId: param.value[2],
              name: param.seriesName,
              data: param.value,
              type: "chooseSeries",
            })
          );
          item.markPoint.data.push({
            name: "chooseSeries",
            value: param.value[1],
            xAxis: param.value[0],
            yAxis: param.value[1],
            itemStyle: {
              zIndex: 999,
            },
          });
        }
      });
      /* document
          .getElementById("monitor")
          .setAttribute("_echarts_instance_", ""); */
  
      // myChart.setOption(option, true)
      // myChart && echarts.init(chartDom).resize();
    });
  
    // 将可以响应点击事件的范围内，鼠标样式设为pointer--------------------
    myChartR.getZr().off("mousemove");
    myChartR.getZr().on("mousemove", function (params) {
      const { topTarget } = params;
      // 给折线的鼠标悬浮 变为 小手
      if (topTarget?.z === 2) {
        myChartR.getZr().setCursorStyle("pointer");
      }
    });
    /*  myChart && option && myChart.setOption(option, true)
         myChart.hideLoading() */
    var listener = () => {
      myChartR.resize();
    };
    EleResize.on(chartDom, listener);
  }


  // 监听图例选择变化事件
  myChartR.off("legendselectchanged");
  myChartR.on('legendselectchanged', function (params) {
    if (!myChartR) return;
    const selected = params.selected;
    const option = myChartR.getOption();
    if (!option || !Array.isArray(option.series) || !Array.isArray(option.yAxis)) return;

    // 检查每个series的显示状态，决定y轴是否显示
    const series = option.series;
    const yAxisVisible = option.yAxis.map(() => false);

    // 遍历所有series，确定是否有对应y轴的可见系列
    series.forEach(s => {
      const axisIndex = Number(s.yAxisIndex || 0);
      if (selected[s.name] && yAxisVisible[axisIndex] !== undefined) {
        yAxisVisible[axisIndex] = true;
      }
    });

    // 动态设置y轴的显示和隐藏
    option.yAxis = option.yAxis.map((axis, axisIndex) => ({
      ...axis,
      show: yAxisVisible[axisIndex],
    }));

    // 更新图表
    myChartR.setOption(option);
  });

};
const updatedSeriesF = (dataList) => {
    if (!myChartR) return;
    let xAxisData = [];
  
    dataList.forEach((item, index) => {
      item.data?.forEach(d => {
        if (d && d.name) xAxisData.push(d.name);
      });
    });
  
    // 去重 + 排序
    xAxisData = [...new Set(xAxisData)].sort((a, b) => {
      const momentA = moment(new Date(a));
      const momentB = moment(new Date(b));
      return momentA - momentB;
    });
  
    // 构造新的 series 数据
    const updatedSeries = dataList.map((series,index) => ({
      ...series,
      data: (series.data || []).map(item => ({
            name: item.name,
            value: [
            item.name,
            Number.isFinite(Number(item?.value?.[1])) ? Number(item?.value?.[1]) : null,
            item?.value?.[2] || ''
            ],
        })),
      yAxisIndex: index,
    }));
  
    // 更新 ECharts 图表
    myChartR.setOption({
        xAxis: [{
            type: 'category',
            data: xAxisData
        }],
        // yAxis,
        series: updatedSeries
        });
  
}
/**
 * 获取同Y轴的最大值和最小值
 * @param {*} data 折线数据
 * @param {*} index 索引
 * @returns 
 */
const yAxisListFun = (data,index)=>{
    let color = [
        "rgba(34, 187, 232, 1)",
        "rgb(48, 61, 255)",
        "rgba(252, 190, 92, 0.7)",
        "rgba(134, 92, 226,.7)",
        "rgba(60, 146, 173,.7)",
        "rgba(50, 246, 173,.7)",
      ];
    var offsets = [0, 35, 0, 35];          
    var nooffsetData = [0, 30, 0, 30, 60];
    let maxRange = getIntervals(data.yData, 5).intervals;
    // console.log(maxRange,"series");
    return {
      nameLocation: "end", // 名称的位置，可以是 'start', 'middle', 'end'
      nameTextStyle: {
        color: color[index], // 设置名称的颜色
      },
      position: index > 1 ? "right" : "left",
      // boundaryGap: ["10%", "10%"],
      min: maxRange[0], // 设置Y轴最小值
      max: maxRange[maxRange.length - 1], // 设置Y轴最大值
      splitNumber: 5, // 分成5格
      interval: maxRange[1] - maxRange[0], // 每格的间隔
      offset:
      data.yData && data.yData.length > 0
          ? offsets[index]
          : nooffsetData[index],
      scale: true,
      axisLabel: {
        show: true,
        textStyle: {
          color: color[index],
        },
      },
      type: "value",
      name: data.unit,
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: color[index],
        },
        show: false,
        onZero: true,
      },
    };
}

const spectrumEcharts4 = (options, flag) => {
    let { chartDom, dataLists } = options;
    let dataList = dataLists.filter(item=>item.is_checked)

    if(flag){/* flag 用于只更新数据 */
        updatedSeriesF(dataList)
    }else{
        let title = options.title || {};
        let yAxis = [];
        let legendList = [];
        let color = [
            "rgba(34, 187, 232, 1)",
            "rgb(48, 61, 255)",
            "rgba(252, 190, 92, 0.7)",
            "rgba(134, 92, 226,.7)",
            "rgba(60, 146, 173,.7)",
            "rgba(50, 246, 173,.7)",
          ];
        // ✅ 正确释放已有实例
        const oldInstance = echarts.getInstanceByDom(chartDom);
        if (oldInstance) {
          oldInstance.dispose();
        }
        // ✅ 初始化图表并赋值
        myChartR = echarts.init(chartDom);
      if (dataList && dataList.length) {
        dataList.map((data, index) => {
          legendList.push(data.name);
          if (data.areaStyle) {
            return;
          }
          data.step = data.dtype && data.dtype == "number" ? "end" : false;
          data.data.map((item) => {
            item.name = new Date(item.name).toString();
          });
    
          data.yAxisIndex = index;
        //   const yaxis = yAxisListFun(data,index)
        var offsets = [0, 0, 38, 30, 60, 60];
        console.log(index,"index");
        let yaxis = {
          position: ((index+1)%2) == 0 ? "right" : "left",
          offset: offsets[index],
          max: 10000,
          min: 5000,
          splitNumber: 5, // 分成5格
          // boundaryGap: ["20%", "50%"],
          axisLabel: {
            show: true,
            textStyle: {
              color: color[index],
            },
          },
          type: "value",
          name: data.unit,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: color[index],
            },
            show: false,
            onZero: true,
          },
        };
        if(options.equip_data.id == IS_DEMO_PAPER_MAKING_EP1000_ID){
            yaxis.max = 13000;
            yaxis.min = 8000;
        }
          yAxis.push(yaxis);
        });
      } else {
        yAxis.push({
          type: "value",
          name: "",
          // boundaryGap: ["20%", "50%"],
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
            onZero: true,
            lineStyle: {
              color: "rgba(0,0,0)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              //y轴分隔线样式设置
              color: "#F3F6F9A1", //颜色
              type: "solid", //虚线
            },
          },
        });
      }
      console.log(dataList,"dataList");
      let option = {
        title: {
          text: title,
          show: false,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            axis: "x",
            animation: false,
          },
          formatter: function (params) {
            let returnData = "";
            for (let i = 0; i < params.length; i++) {
              if (params[i].seriesName != "") {
                let indexColor = params[i].color;
                if (params[i].seriesName == "动态阈值") {
                  params[i].seriesName = "动态阈值（高）";
                  params[i + 1].seriesName = "动态阈值（低）";
                }
                returnData +=
                  '<div style="margin-top:10px;">' +
                  '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:' +
                  indexColor +
                  '"></span>' +
                  '<span style="display:inline-block;margin-right:10px">' +
                  params[i].seriesName +
                  ":" +
                  "</span>" +
                  params[i].value[1] +
                  "</div>";
              }
            }
            return (
              "<div>" +
              moment(params[0].value[0])
                .tz(localStorage.getItem("tz") || "Asia/Shanghai")
                .format("YYYY-MM-DD HH:mm:ss.SSS") +
              "</div>" +
              returnData
            );
          },
        },
        legend: {
          data: legendList,
        //   orient:legendList.length>2?"vertical":"horizontal", //超过三个就换行
          show: true,
          bottom: 0,
          itemGap: 10,
          itemWidth: 10,
          itemHeight: 10,
          icon: 'rect',
          textStyle: {
             color: '#fff',
             fontSize: 12,
             rich: {
                a: {
                   verticalAlign: 'middle'
                }
             },
             padding: [0, 0, -2, 0]
          }
        },
        grid: {
          top:30,
          left:legendList.length>2?95:38,
          right:50,
          bottom:20,
        },
        xAxis: [
          {
            type: "category",
            splitNumber: 5,
            splitLine: {
              show: false,
              lineStyle: {
                //y轴分隔线样式设置
                color: "#F3F6F97", //颜色
                type: "solid", //虚线
              },
            },
            axisTick: {
              show: false,
            },
            position: "bottom",
            axisLine: {
              show: true,
              onZeroAxisIndex: "-20",
            },
            axisLabel: {
              show:false
            },
          },
        ],
        yAxis: yAxis,
        color,
        triggerEvent: true,
        series: dataList,
      };
      setTimeout(() => {
        /* document
                .getElementById("monitor")
                .setAttribute("_echarts_instance_", ""); */
                myChartR.clear();
                myChartR && option && myChartR.setOption(option);
                myChartR && myChartR.hideLoading();
      }, 500);
    
      // 将可以响应点击事件的范围内，鼠标样式设为pointer--------------------
      myChartR.getZr().on("mousemove", function (params) {
        const { topTarget } = params;
        // 给折线的鼠标悬浮 变为 小手
        if (topTarget?.z === 2) {
          myChartR.getZr().setCursorStyle("pointer");
        }
      });
      /*  myChart && option && myChart.setOption(option, true)
           myChart.hideLoading() */
      var listener = () => {
        myChartR.resize();
      };
      EleResize.on(chartDom, listener);
    }
  
  
    // 监听图例选择变化事件
    myChartR.on('legendselectchanged', function (params) {
      const selected = params.selected;
      const option = myChartR.getOption();
  
      // 检查每个series的显示状态，决定y轴是否显示
      const series = option.series;
      let leftAxisVisible = false;
      let rightAxisVisible = false;
  
      // 遍历所有series，确定是否有对应y轴的可见系列
      series.forEach(s => {
        if (selected[s.name]) {
          if (s.yAxisIndex === 0) {
            leftAxisVisible = true;
          } else if (s.yAxisIndex === 1) {
            rightAxisVisible = true;
          }
        }
      });
  
      // 动态设置y轴的显示和隐藏
      option.yAxis[0].show = leftAxisVisible;
      option.yAxis[1].show = rightAxisVisible;
  
      // 更新图表
      myChartR.setOption(option);
    });
  
};



const progressChart = (options) => {
    let { chartDom, dataList, lineColor } = options;
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart == null || myChart == "") {
        myChart = echarts.init(chartDom);
    }
    let option = {
        grid: {
            left: "-20px",
            right: "10%",
            top: "10px",
            bottom: "35px",
            containLabel: true,
        },
        xAxis: {
            boundaryGap: false,
            // max: 100,
            // min:0,
            // min:Number(dataList['operationThresholdLow'])*0.5,
            // max: Number(dataList['operationThresholdHigh'])*1.2,
            splitNumber: 5,
            // 刻度线
            axisTick: {
                inside: true,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#000",
                },
            },
            splitLine: {
                show: false,
            },
            axisLabel: {
                show: false,
            },
        },
        yAxis: {
            min: 1,
            max: 200,
            splitNumber: 6,
            type: "value",
            show: false,
        },
        series: [
            {
                data: [[dataList["value"], 1]],
                type: "line",
                color: lineColor || "#00F957",
                barWidth: 10,
                label: {
                    show: true,
                    formatter: (e) => {
                        return e.data[0] + dataList["unit"];
                    },
                },
                symbol: "roundRect",
                symbolSize: 10,
                symbolOffset: [0, -2],
                lineStyle: {
                    color: "#5470C6",
                    width: 4,
                    type: "dashed",
                },
                markPoint: {
                    symbol: "triangle",
                    symbolSize: 8,
                    position: "bottom",
                    symbolOffset: [0, 5],
                    data:
                        dataList["operationThresholdHigh"].length > 0
                            ? [
                                {
                                    name: "Max",
                                    xAxis: Number(dataList["operationThresholdHigh"]),
                                    yAxis: 1,
                                    itemStyle: {
                                        color: "#ED5E5E",
                                        width: 2,
                                    },
                                },
                                {
                                    name: "Min",
                                    xAxis: Number(dataList["operationThresholdLow"]),
                                    yAxis: 1,
                                    itemStyle: {
                                        color: "#CA1D40",
                                        width: 2,
                                    },
                                },
                                {
                                    name: "Max",
                                    xAxis: Number(dataList["standardThresholdHigh"]),
                                    yAxis: 1,
                                    itemStyle: {
                                        color: "#F7B84B",
                                        width: 2,
                                    },
                                },
                                {
                                    name: "Min",
                                    xAxis: Number(dataList["standardThresholdLow"]),
                                    yAxis: 1,
                                    itemStyle: {
                                        color: "#F7B84B",
                                        width: 2,
                                    },
                                },
                            ]
                            : [],
                },
            },
        ],
    };
    myChart && option && myChart.setOption(option, false);
    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)
};

/* 模型基础类型 */
const modelBaseChart = (options, callback, selectNode) => {
    let symbolSize = 80;
    let { chartDom, data } = options;
    data.nodes.forEach(node => {
        node.symbolSize = symbolSize / node.level
        // if (node.level == 1) {
        //     node.label = { position: 'inside' }
        // } else {
        //     node.label = { position: 'bottom' }
        // }
    })

    let repulsion = () => {
        if (data.links.length < 5) {
            return 800
        } else {
            return 500
        }
    }

    let myChart = chartDom && echarts.init(chartDom);

    let option = {
        title: {
            text: "",
        },
        tooltip: {
            show: false
        },
        legend: {
            show: false,
        },
        toolbox: {
            show: false,
        },
        cursor: 'pointer',
        animation: false,
        color: data.color || randomColor({
            luminosity: 'light',
            hue: 'blue'
        }),
        series: [
            {
                name: "模型基础类型",
                type: "graph",
                layout: "force",
                // center: ["50%", "50%"],
                // draggable: true,
                focusNodeAdjacency: true,//是否在鼠标移到节点上的时候突出显示节点以及节点的边和邻接节点。
                selectedMode: true,
                animationDuration: function (idx) {
                    // 越往后的数据时长越大
                    return idx * 2;
                },
                select: {
                    itemStyle: {
                        borderWidth: 3,
                        borderColor: '#C3A35B'
                    }
                },
                force: {
                    repulsion: repulsion()
                },
                data: data.nodes,
                links: data.links,
                categories: data.categories,
                roam: true,
                emphasis: {
                    focus: 'adjacency',
                    scale: 1.2,
                    itemStyle: {
                        borderWidth: 3,
                        borderColor: '#C3A35B'
                    }
                },
                label: {
                    show: true,
                    color: '#000',
                    position: 'bottom'
                },
                lineStyle: {
                    curveness: 0.3,
                    color: 'source',
                    width: 2
                },
            },
        ],
    };
    myChart && option && myChart.setOption(option);
    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)

    /* 选中搜索的node节点 */
    if (selectNode) {
        myChart.dispatchAction({
            type: "select",
            name: selectNode
        })
    }
    /* 点击事件 */
    myChart.on('click', (node) => {
        let options = {
            x: node.event.event.pageX,
            y: node.event.event.pageY,
            name: node.name,
            node: node.data
        }
        callback(options)
    })

};


const getRandomMath = (min, max) => {
    let position;
    position = Math.floor(Math.random() * (max - min)) + min
    return position
}

const getCenter = (hasBig, dataCount, nodeCount, lessCount) => {
    if (dataCount == 1) {
        return ['50%', '50%']
    }
    if (hasBig) {
        if (nodeCount > 50) {
            return ['75%', '50%']
        } else {
            return [lessCount / 2 == 0 ? "10%" : "20%", (80 - lessCount * 25).toString() + "%"]
        }
    } else {
        return [(80 - lessCount * 25).toString() + "%", "50%"]
    }
}

const getBorderColor = (color, percentage) => {
    let r = parseInt(color.substr(1, 2), 16)
    let g = parseInt(color.substr(3, 2), 16)
    let b = parseInt(color.substr(5, 2), 16)

    let result = ""

    result += parseInt(r * percentage).toString(16)

    result += parseInt(g * percentage).toString(16)

    result += parseInt(b * percentage).toString(16)
    return "#" + result
}

/* 模型基础类型 */
const modelBaseChart1 = (options, callback, selectNode) => {
    let symbolSize = 80;
    let { chartDom, data } = options
    let repulsion
    let calcZoom
    let series = []
    let lessCount = 0
    let hasBig = false
    data.forEach((opt) => {
        if (opt.nodes.length > 50) {
            hasBig = true
        }
    })

    data.forEach((opt) => {
        repulsion = () => {
            if (opt.links.length < 5) {
                return 800
            } else {
                return 300
            }
        }

        calcZoom = () => {
            if (opt.links.length > 50) {
                return 0.7
            } else if (opt.links.length > 100) {
                return 0.6
            } else if (opt.links.length > 200) {
                return 0.5
            } else {
                return 1
            }
        }

        opt.nodes.forEach(node => {
            node.symbolSize = symbolSize / node.level;
            // node.x = getRandomMath(30, chartDom.offsetWidth);
            // node.y = getRandomMath(chartDom.offsetTop, chartDom.offsetHeight);
            node.itemStyle = { color: opt.color };
        })
        let single = {
            name: "模型基础类型",
            type: "graph",
            layout: "force",
            // draggable: true,
            focusNodeAdjacency: true,//是否在鼠标移到节点上的时候突出显示节点以及节点的边和邻接节点。
            selectedMode: true,
            center: getCenter(hasBig, data.length, opt.nodes.length, lessCount),
            force: {
                repulsion: repulsion(),
                initLayout: "circular",
                layoutAnimation: false
            },
            animationDuration: function (idx) {
                // 越往后的数据时长越大
                return idx * 2;
            },
            // color:['#6691E7','#EA7CCC','#FC8452','#FAC858','#50C3E6'],
            select: {
                itemStyle: {
                    borderWidth: 5,
                    borderColor: getBorderColor(opt.color, 0.5),
                    // borderType: 'dotted'
                }
            },
            data: opt.nodes,
            links: opt.links,
            categories: opt.categories,
            roam: true,
            animation: false,
            zoom: calcZoom(),
            emphasis: {
                focus: 'adjacency',
                scale: 1.2,
                itemStyle: {
                    borderWidth: 3,
                    borderColor: getBorderColor(opt.color, 0.7)
                }
            },
            label: {
                show: true,
                color: '#000',
                position: 'right'
            },
            lineStyle: {
                curveness: 0.3,
                color: 'source',
                width: 1,
                opacity: 0.7
            },
        }

        if (opt.nodes.length < 50) {
            lessCount++
        }

        series.push(single)
    })
    let myChart = chartDom && echarts.init(chartDom);

    let option = {
        title: {
            text: "",
        },
        tooltip: {
            show: false
        },
        legend: {
            show: false,
        },
        toolbox: {
            show: false,
        },
        cursor: 'pointer',
        animation: false,
        series: series
    };
    myChart && option && myChart.setOption(option,true);
    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)

    /* 选中搜索的node节点 */
    if (selectNode) {
        myChart.dispatchAction({
            type: "select",
            name: selectNode
        })
    }
    /* 点击事件 */
    myChart.on('click', (node) => {
        let options = {
            x: node.event.event.pageX,
            y: node.event.event.pageY,
            name: node.name,
            node: node.data
        }
        callback(options)
    })

};
/* 健康报告柱状图 */ 
const examinationChat = ({ chartDom, listDate,
    listData,indexNum }, callback) => {
    let myChart = chartDom && echarts.init(chartDom);
    let option = {
        xAxis: {
            type: 'category',
            data: listDate,
            axisLabel: {
                fontWeight: 400,
                fontSize: '12px',
                color: '#ffffff'
            },
        },
        legend: {
            icon: 'circle',
            selectedMode: true,
            orient: 'vertical',
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 6,
            textStyle: {
                color: 'rgba(233, 240, 255, 1)',
                fontSize: 14
            },
            show: false,
            left: '6%',
            top: '5%',
            data: ['体检分数']
        },
        yAxis: {
            type: 'value',
            max: 100,
            interval: 30,
            splitLine: {//分割线配置
                show: false,
            },
            axisLabel: {
                fontWeight: 400,
                fontSize: '12px',
                color: '#ffffff'
            },
        },
        grid: {
            left: "5%",
            right: "1%",
            top: "50px",
            bottom: "35px",
            containLabel: true,
        },
        series: [
            {
                color: ['#6DD6F0'],
                data: listData,
                type: 'bar',
                name: '体检分数',
                barWidth: '50',
                itemStyle:{
                    color:function(param){
                        let color = '#6DD6F0'
                        /* 柱状图渐变颜色 {  
                                type: 'linear',  
                                x: 0,  //从左到右
                                y: 1,  //从上向下
                                x2: 0, //从右向下
                                y2: 0,  //从下向上
                                colorStops: [{  
                                    offset: 0, color: '#6DD6F0' // 0% 处的颜色  
                                }, {  
                                    offset: 1, color: 'rgba(226, 248, 254, 1)' // 100% 处的颜色  
                                }],  
                                global: false // 缺省为 false  
                            }    */
                        if(param.dataIndex == indexNum){
                            color = {  
                                type: 'linear',  
                                x: 0,  //从左到右
                                y: 1,  //从上向下
                                x2: 0, //从右向下
                                y2: 0,  //从下向上
                                colorStops: [{  
                                    offset: 0, color: '#6DD6F0' // 0% 处的颜色  
                                }, {  
                                    offset: 1, color: 'rgba(226, 248, 254, 1)' // 100% 处的颜色  
                                }],  
                                global: false // 缺省为 false  
                            } 
                        }
                        return color;
                    }
                },
                markArea: {
                    data: [
                        [
                            {
                                yAxis: '0',
                                itemStyle: {
                                    color: '#D75186B5'
                                },
                            },
                            {
                                yAxis: '30',
                                itemStyle: {
                                    color: '#D75186B5'
                                },
                            }
                        ],
                        [
                            {
                                yAxis: '30',
                                itemStyle: {
                                    color: '#BB729CD6'
                                },
                            },
                            {
                                yAxis: '60',
                                itemStyle: {
                                    color: '#BB729CD6'
                                },
                            }
                        ],
                        [
                            {
                                yAxis: '60',
                                itemStyle: {
                                    color: '#CBB782B6'
                                },
                            },
                            {
                                yAxis: '90',
                                itemStyle: {
                                    color: '#CBB782B6'
                                },
                            }
                        ],
                        [
                            {
                                yAxis: '90',
                                itemStyle: {
                                    color: '#4DA9B0C4'
                                },
                            },
                            {
                                yAxis: '100',
                                itemStyle: {
                                    color: '#4DA9B0C4'
                                },
                            }
                        ]
                    ]
                },

                markLine: {
                    symbol: ['none', 'none'], //去掉箭头
                    data: [{
                        type: 'average', name: '平均数', label: {
                            formatter: [
                                '设备平均分数',
                                '',
                                ''
                            ].join('\n'),
                            position: 'start',
                            color: '#ffffff',
                            distance: [-80, -30]

                        }, lineStyle: {
                            color: '#ffffff',
                            type: 'solid',
                            width: 3,

                        }
                    }]
                }
            }
        ]
    };
    /* 点击事件 */
    myChart.off('click')
    myChart.on('click', (node) => {
        if (node.componentType == "series") {
            let options = {
                node: node,
                indexNum: node.dataIndex
            }
            callback(options)
        }
    })
    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart && option && myChart.clear()
    myChart && option && myChart.setOption(option);
}
/* 折线图 */ 
const statisticsChart = ({ chartDom, chartData,type='1' }) => {
    let myChart = chartDom && echarts.init(chartDom);
    let series = []
    let unit = ""

    for (let i = 0; i < chartData.length; i++) {
        let _data = []
        for (let j = 0; j < chartData[i].data.length; j++){

            if(type&&moment(moment().add(Number(type),"years")).diff(moment(chartData[i].data[j].ts),'days')>=0){
                _data.push([moment(chartData[i].data[j].ts).format('YYYY-MM-DD'),chartData[i].data[j].value])
            }

        }
        series.push({
            data: _data,
            name: chartData[i].key,
            type: 'line'
        })
        unit = AUDITING_MEASUREMENT_UNIT_MAP[chartData[i].key]
    }

    let isShowLegend = series.length > 0 ? true : false
    let legendOption = {
        show: isShowLegend,
        left: 'center',
        bottom: 'bottom',
        itemWidth: 12,
        itemHeight: 2,
        icon: 'roundRect',
        textStyle: {
            fontSize: 10,
            lineHeight: 11.85,
            fontWeight: 400
        }
    }
    if (series.length > 4) {
        legendOption = {
            show: isShowLegend,
            left: 'center',
            bottom: 1,
            itemWidth: 12,
            itemHeight: 2,
            icon: 'roundRect',
            textStyle: {
                fontSize: 10,
                lineHeight: 11.85,
                fontWeight: 400
            }
        }
    }

    let option = {
        tooltip: {
            show: true,
            trigger: "axis",
            axisPointer: {
                type: "cross",
                axis: "x",
                animation: false,
            },
        },
        grid:{
          left: 50
        },
        legend: legendOption,
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: { show: !isShowLegend }
        },
        yAxis: {
          type: 'value',
          name: unit,
          nameTextStyle: {
            align: 'right'
          },
          nameLocation: 'end',
          position: 'left'
        },
        series: series
    };

    myChart && option && myChart.clear()
    myChart && option && myChart.setOption(option);
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
}
const _statisticsChart = ({ chartDom, measurement_data }) => {
    let myChart = chartDom && echarts.init(chartDom);
    let option = {
        tooltip: {
            show: false,
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '0%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: ['0', '1.3', '2.6', '3.5', '4.8'],
                splitLine: {//分割线配置
                    show: false,
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    show: false,
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#495057',
                    align: 'right',
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                max: 100,
                splitLine: {//分割线配置
                    show: false,
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    show: false,
                }
            }
        ],
        series: [
            {
                name: 'Email',
                type: 'bar',
                stack: 'Ad',
                barWidth: '99%',
                emphasis: {
                    focus: 'series'
                },
                data: [{ value: 5, itemStyle: { color: 'rgba(237, 94, 94, 0.7)', padding: 10 } }, { value: 5, itemStyle: { color: 'rgba(248, 197, 51, 0.7)' } }, { value: 5, itemStyle: { color: 'rgba(19, 197, 107, 0.7)' } }, { value: 5, itemStyle: { color: 'rgba(248, 197, 51, 0.7)' } }, { value: 5, itemStyle: { color: 'rgba(237, 94, 94, 0.7)' } }]
            },
            {
                name: 'Email',
                type: 'bar',
                stack: 'Ad',
                barWidth: '99%',
                emphasis: {
                    focus: 'series'
                },
                data: [{ value: 2, itemStyle: { color: 'rgba(237, 94, 94, 0)' } }, { value: 2, itemStyle: { color: 'rgba(248, 197, 51, 0)' } }, { value: 2, itemStyle: { color: 'rgba(19, 197, 107, 0)' } }, { value: 2, itemStyle: { color: 'rgba(248, 197, 51, 0)' } }, { value: 2, itemStyle: { color: 'rgba(237, 94, 94, 0)' } }]
            },
            {
                name: 'Union Ads',
                type: 'bar',
                stack: 'Ad',
                emphasis: {
                    focus: 'series'
                },
                label: {
                    show: true,
                    position: 'top',
                    fontSize: "1.25rem",
                    fontWeight: 500,
                    color: "#495057",
                    formatter: (val) => {
                        return `${val.data.value}` + '%'
                    }
                },
                data: [{ value: measurement_data.num1, itemStyle: { color: 'rgba(237, 94, 94, 0.7)' } }, { value: measurement_data.num2, itemStyle: { color: 'rgba(248, 197, 51, 0.7)' } }, { value: measurement_data.num3, itemStyle: { color: 'rgba(19, 197, 107, 0.7)' } }, { value: measurement_data.num4, itemStyle: { color: 'rgba(248, 197, 51, 0.7)' } }, { value: measurement_data.num5, itemStyle: { color: 'rgba(237, 94, 94, 0.7)' } }],
            },

        ]
    };
    myChart && option && myChart.clear()
    myChart && option && myChart.setOption(option);
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
}
const standardChart = ({ chartDom, measurement_data, status }) => {
    let myChart = chartDom && echarts.init(chartDom);
    var statusData = {
        '过低': 0,
        '较低': 1,
        '正常': 2,
        '较高': 3,
        '过高': 4,
    }

    let option = {
        tooltip: {
            trigger: 'axis',
            show: false,
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: ['0', '1.3', '2.6', '3.5', '4.8'],
                splitLine: {//分割线配置
                    show: false,
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    show: false,
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#495057',
                    align: 'right',
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                max: 50,

                splitLine: {//分割线配置
                    show: false,
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    show: false,
                }
            }
        ],
        series: [
            {
                name: 'Email',
                type: 'bar',
                stack: 'Ad',
                barWidth: '99%',
                markPoint: {
                    symbolSize: 60,
                    itemStyle: {
                        color: 'rgba(237, 94, 94, 0.7)'
                    },
                    data: [{
                        name: '周最低', xAxis: statusData[status], yAxis: 5, value: measurement_data, itemStyle: {
                            color: ['rgba(237, 94, 94, 0.7)', 'rgba(248, 197, 51, 0.7)',
                                'rgba(19, 197, 107, 0.7)',
                                'rgba(248, 197, 51, 0.7)',
                                'rgba(237, 94, 94, 0.7)'][statusData[status]]
                        }
                    }]
                },
                emphasis: {
                    focus: 'series'
                },
                data: [{ value: 5, itemStyle: { color: 'rgba(237, 94, 94, 0.7)', padding: 10 } }, { value: 5, itemStyle: { color: 'rgba(248, 197, 51, 0.7)' } }, { value: 5, itemStyle: { color: 'rgba(19, 197, 107, 0.7)' } }, { value: 5, itemStyle: { color: 'rgba(248, 197, 51, 0.7)' } }, { value: 5, itemStyle: { color: 'rgba(237, 94, 94, 0.7)' } }]
            },
        ]
    };
    myChart && option && myChart.clear()
    myChart && option && myChart.setOption(option);
    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)
}
const markChart = ({ chartDom, markData, score_color}) => {
    let myChart = chartDom && echarts.init(chartDom);
    let option = {
        title: [{
            text: markData.data + ' 分',
            left: 'center',
            top: '40%',
            textStyle: {
                color: '#FFFFFF',
                fontSize: 32,
                fontWeight: 400
            }
        },
        {
            text: '较上次',
            left: '30%',
            top: '60%',
            textStyle: {
                color: '#FFFFFF',
                fontSize: 12,
                fontWeight: 500
            }
        }
            ,
        {
            text: (markData.score_diff_last > 0 ? '▲  ' : '▼  ') + markData.score_diff_last,
            top: '60%',
            left: "50%",
            textStyle: {
                color: markData.score_diff_last > 0 ? '#30FD96' : '#FF3535',
                fontSize: 12,
                fontWeight: 500
            }
        }
            ,
        {
            text: '较初次',
            left: '30%',
            top: '70%',
            textStyle: {
                color: '#FFFFFF',
                fontSize: 12,
                fontWeight: 500
            }
        }
            ,
        {
            text: (markData.score_diff_first > 0 ? '▲  ' : '▼  ') + markData.score_diff_first,
            top: '70%',
            left: "50%",
            textStyle: {
                color: markData.score_diff_first > 0 ? '#30FD96' : '#FF3535',
                fontSize: 12,
                fontWeight: 500
            }
        }
        ],
        grid: {
            left: '0%',
            right: '0%',
            bottom: '0%',
            top: '0%',
            containLabel: true
        },
        series: [
            {
                name: 'Access From',
                type: 'pie',
                hoverAnimation: false,
                radius: '94%',
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                labelLine: {
                    show: false
                },
                data: [
                    { value: markData.data, name: 'Search Engine', itemStyle: { color: score_color } },
                ],
            },
            {
                name: 'Access From',
                type: 'pie',
                hoverAnimation: false,
                radius: ['96%', '100%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                labelLine: {
                    show: false
                },
                data: [
                    { value: markData.data, name: 'Search Engine', itemStyle: { color: score_color } },
                    { value: (100 - Number(markData.data)), name: 'Direct', itemStyle: { color: '#00000000' } },
                ]
            }
        ]
    };
    myChart && option && myChart.clear()
    myChart && option && myChart.setOption(option);
    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)

}
const clientChart = (options) => {
    let { chartDom,name1,name2,monthList,current_data,last_data } = options;

    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    let option = {
        legend: {
            right: 'center',
            top: 0,
            icon: 'circle',
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 37,
            textStyle: {
                fontSize: 16,
                fontWeight: 'normal',
                color: '#FFFFFFA8'
            }
        },  
    grid: {
        left: '5%',
        right: '5%',
        top: '15%',
        bottom: '5%',
        containLabel: true
    },
    tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(60, 66, 84, 0.70)',
        borderWidth: 0,
        textStyle: {
            color: '#FFFFFF'
        },
        axisPointer:{
            type:'line',
            lineStyle:{
                color:'rgba(50, 216, 205, 1)'
            },
        }
    },
    xAxis: [{
        type: 'category',
        boundaryGap: 1,
         axisLine: {
        show: false
      },
      axisLabel: {
        color: '#A1A7B3'
      },
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      
        data: monthList
    }],
        yAxis: [{
            name:'KWh',
            type: 'value',
            padding:5,
            // max: 1000,
           splitLine: {
        show: true,
        lineStyle: {
          color: '#B6B7BC33',
          type: 'dashed'
        }
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        show: true,
        margin: 10,
        textStyle: {
          color: '#A1A7B3'

        }
      },
      axisTick: {
        show: false
      }
        },

    ],
    series: [
        {
            name: name1,
            type: 'line',
            smooth:true,
            symbolSize: 5,
            showSymbol:false,
            itemStyle: {
                normal: {
                    color: '#23D0C4',
                    lineStyle: {
                        color: "#23D0C4",
                        width: 2
                    },
                }
            },
             areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: 'rgba(50, 216, 205, 1)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(255, 255, 255, 0.2)'
                        }
                    ], false),
                }
            },
            data:current_data
        },
        {
            name: name2,
            type: 'line',
            smooth:true,
            symbolSize: 5,
            showSymbol:false,
            itemStyle: {
                normal: {
                    color: '#246CF9',
                    lineStyle: {
                        color: "#246CF9",
                        width: 2
                    },
                }
            },
             areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: '#246BF982'
                        },
                        {
                            offset: 1,
                            color: '#246BF933'
                        }
                    ], false),
                }
            },
            data: last_data
        },
    ]
};
    
var listener = () => {

    myChart.resize()
}
EleResize.on(chartDom, listener)
myChart.clear()
myChart && option && myChart.setOption(option)
}
//EnergyConsumption706
function rand(maxNum, minNum, decimalNum){
    var max = 0,
        min = 0;
    minNum <= maxNum
        ? ((min = minNum), (max = maxNum))
        : ((min = maxNum), (max = minNum));
    // switch (arguments.length) {
    //     case 1:
    //     return Math.floor(Math.random() * (max + 1));
    //     break;
    //     case 2:
    //     return Math.floor(Math.random() * (max - min + 1) + min);
    //     break;
    //     case 3:
    //     return (Math.random() * (max - min) + min).toFixed(decimalNum);
    //     break;
    //     default:
    //     return Math.random();
    //     break;
    // }
    if(arguments.length == 1){
        return Math.floor(Math.random() * (max + 1));
    }else if(arguments.length == 2){
        return Math.floor(Math.random() * (max - min + 1) + min);
    }else if(arguments.length == 3){
        return (Math.random() * (max - min) + min).toFixed(decimalNum);
    }else{
        return Math.random();
    }
}
const chart9 = (id, legendData, data) => {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    option = {
        backgroundColor: '#ffffff',
        legend: {
            data: legendData,
            bottom: 5,
            textStyle: {
                fontSize: 20,
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            top: '9%',
            bottom: '13C56B%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            axisTick: {
                show: false
            },
            axisLabel: {
                margin: 15,
                fontSize: 18
            },

            data: data
        },
        yAxis: {
            type: 'value',
            name: 'kWh',
            nameTextStyle: {
                fontSize: 18

            },
            max: 2600,
            axisLabel: {
                fontSize: 18
            },
            splitNumber: 9, // 设置y轴刻度间隔个数
            splitLine: {
                show: true,

            },

        },
        series: [
            {
                name: legendData[0],
                data: [2300, 2300, 2300, 2300, 2300, 2300, 2300, 2300, 2300, 2300, 2300, 2300, 2300, 2300, 2300, 2300],
                type: 'line',
                color: '#B8E795',

                symbol: 'none',
                lineStyle: {
                    width: 2,
                    color: '#C6E7AD',
                    type: 'solid'
                },
                areaStyle: {
                    color: '#B8E795',
                },
            },
            {
                name: legendData[1],

                data: [3, 4, 5, 6, 7, 8, 9, 9.5, 9.8, 9, 5.3, 2.3, 2.2, 1, 2, 3].map(() => {
                    return rand(470, 660)
                }),
                type: 'line',
                color: '#90A3DF',

                symbol: 'none',
                lineStyle: {
                    width: 2,
                    color: '#90A3DF',
                    type: 'solid'
                },
                areaStyle: {
                    color: '#7F96E3'
                }

            },
        ]
    };

    option && myChart.setOption(option);
    window.addEventListener("resize", () => { myChart.resize(); });

}
/* 圆形进度条 */
const circleEcharts = (options) => {
    let { chartDom, dataList, color } = options;
    let title = options.title || {}
    let myChart = chartDom && echarts.init(chartDom);
    let option = {
        color: color,
        title: [{
            text: dataList[0].value + '%',
            subtext: title.subtext || '',
            top: 'center',
            left: 'center',
            textStyle: {
                fontSize: title.fontSize || '12px',
                color: '#000',//圆环中心文字字体颜色
            }
        }],
        series: [
            {
                type: 'pie',
                radius: ['75%', '85%'], //控制圆环大小
                center: ['50%', '50%'], //控制圆环位置
                data: dataList,
                hoverAnimation: false,
                itemStyle: {
                    borderWidth: 0
                },
                labelLine: {
                    length: 0,
                    length2: 0,
                    lineStyle: {
                        color: '#e6e6e6'
                    }
                }
            }
        ]
    };
    myChart && option && myChart.setOption(option)
}

//监控页面
//辅助线，等高图
const polygonChart = (chartDom) => {
    var myChart = echarts.init(chartDom);
    var option;
    
  //红色辅助线
  let redLinesData = [
    [
      [2.4, 43],
      [4, 41],
      [5, 37],
      [5, 37],
      [6, 31],
      [6.5, 26]
    ],
    [
      [3.45, 53],
      [5, 50.5],
      [6, 45]
    ],
    [
      [4.4, 62],
      [6, 58.8],
      [6.8, 55.5]
    ],
    [
      [5.5, 69],
      [6, 68.8],
      [7, 67.8],
      [8, 66],
      [8.4, 65]
    ],
    [
      [2.4, 43],
      [3.45, 53],
      [4.4, 62],
      [5.5, 69]
    ]
  ];
const redLinesSeries = redLinesData.map((line) => ({
      type: 'line',
      coordinateSystem: 'cartesian2d',
      polyline: true,
      data: line,
      smooth: true,
      showSymbol: false, //只有在 tooltip hover 的时候显示
      lineStyle: {
        color: '#ffffff', // 红色
        width: 1.5,
        type: 'solid'
      }
    }));
    
// 文字数据（0.87）
const labelData = [
  { x: 2.0, y: 43, value: 0.625 },
  { x: 3.0, y: 53, value: 0.75 },
  { x: 3.8, y: 62, value: 0.875 },
  { x: 4.9, y: 69, value: 1 }
];

// 绿色等高线
// 每一层等高线区域的数据（从最小值到最大值分层）
const contour = [
  {
    data: [
      [2.45, 43.2],
      [2.65, 41.7],
      [2.85, 40.2],
      [3.1, 38.3],
      [3.4, 36.5],
      [3.8, 34.3],
      [4.2, 32.5],
      [4.5, 31],
      [5.0, 29],
      [5.23, 28],
      [5.5, 27.1],
      [5.75, 26.5],
      [6.0, 26.2],
      [6.25, 26.05],
      [6.5, 26],
      [7.68, 50],
      
      [8.4, 65],[8.3, 65.3],[7, 67.6],[6, 68.6],
      [5.5, 69],[5.4, 68.5],[4.42, 62], [3.49, 53.2],
      [2.45, 43.2],
    ],
    color: '#f2b314',
    z: 4
  },
  
];

// 构建填充 polygon
const contourSeries = contour.map((item, i) => {
  return {
    name: 'Level' + i,
    type: 'line',
    // smooth: true,
    symbol: 'none',
    lineStyle: { 
      width: 1,
      color:"#f2b314" 
    },
    areaStyle: {
    color: new echarts.graphic.RadialGradient(0.6, 0.22, 0.54, [
      { offset: 0, color: '#3db3f0' },
      { offset: 1, color: '#3fd58f' }
    ]),
  // opacity: 1
    },
    data: item.data,
    z: item.z
  };
});
const series = [
    // 红色辅助线
    ...redLinesSeries,
    // 文字标签
    {
      type: 'scatter',
      color: '#0f172a',
      coordinateSystem: 'cartesian2d',
      symbolSize: 10,
      label: {
        show: true,
        formatter: (params) => params.data[2],
        color: '#fff',
        fontSize: 15,
        position: 'inside'
      },
      data: labelData.map((d) => [d.x, d.y, d.value])
    },
    // 填充绿色等高区域
    ...contourSeries
    ]
option = {
//   backgroundColor: '#0f172a',
    grid: {
        top:10,
        left: '12%',
        right: 10,
        bottom: '12%', 
    },
  xAxis: {
    type: 'value',
    data: [0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0],
    max: 9.0,
    axisLabel: {
      interval: 0 // 显示所有标签
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: '#747985',
      }
    },
    splitNumber: 8,
    boundaryGap: false, // 让刻度对齐
  },
  yAxis: {
    type: 'value',
    data: [0, 10, 20, 30, 40, 50, 60, 70, 80],
    max: 80,
    splitLine: {
      show: true,          
      lineStyle: {
        color: '#747985',
      }
    },
    splitNumber: 7,
    boundaryGap: false, // 让刻度对齐
    name:  i18n.global.t('smart_OM_model_paper_making.vacuum'),  // 添加 Y 轴的单位标题
    nameLocation: 'middle', // 将单位标题放置在中间
    nameTextStyle: {
      color: '#fff',  // 设置单位标题的文字颜色
      fontSize: 12,   // 设置单位标题的字体大小
      padding: [0, 0, 15, 0]  // 控制单位标题与图表的间距
    },
  },
  series: [
    ...series,
    //闪烁的点
    {
      type:'effectScatter',
      // 有三种: cartesian2d(二维的直角坐标系) polar(极坐标系) geo(地理坐标系) ,此需求使用cartesian2d
      coordinateSystem: 'cartesian2d',
      // 单个闪烁点 ↓
      data: [{value:[6.2,59.8],symbolSize:8}], //2d坐标系--[x轴, y轴, 标记大小]
      // 何时显示特效:'render'-绘制完成后显示特效 'emphasis'-高亮（hover）的时候显示特效
      showEffectOn: 'render',
      // 涟漪特效配置
      rippleEffect: {
        // 波纹的绘制方式,可选'stroke'和'fill'
        brushType: 'stroke'
      },
      hoverAnimation: true,
      itemStyle: {
        normal: {
          color: '#f5c243',
          shadowBlur: 30,
          shadowColor: '#fff'
        }
      },
      zlevel:1
    }
  ],

};

let data = [
    [6,50],
    [5.89,48.6],
    [5.36,58],
    [5.01,50],
    [6.39,60],
    [5.36,51],
    [5.40,50],
    [6.58,55.55],
  ]
let index = 0  
// 设置定时器每5秒更新一次闪烁点
setInterval(() => {
  // 随机更新闪烁点的位置
  const newFlashPoint = { 
    value: data[index], // 随机更新闪烁点的位置
    symbolSize: 8
  };
  if(index == data.length-1){
    index = 0
  }else{
    index += 1
  }
  // 更新闪烁点数据
  myChart.setOption({
    series: [
      ...series,
      {
      type: 'effectScatter',
      coordinateSystem: 'cartesian2d',
      data: [newFlashPoint], // 更新闪烁点
      showEffectOn: 'render',
      rippleEffect: {
        brushType: 'stroke'
      },
      hoverAnimation: true,
      itemStyle: {
        normal: {
          color: '#f5c243',
          shadowBlur: 30,
          shadowColor: '#fff'
        }
      },
      zlevel: 1
    }]
  });  // false 表示不重置整个 option，只更新闪烁点

}, 5000); // 每5秒更新一次闪烁点
    
    option && myChart.setOption(option);
    
}


export {
    spectrumEcharts,
    spectrumEcharts1,
    spectrumEcharts2,
    spectrumEcharts3,
    spectrumEcharts4,
    progressChart,
    modelBaseChart,
    modelBaseChart1,
    getRandomMath,
    examinationChat,
    statisticsChart,
    standardChart,
    markChart,
    clientChart,
    chart9,
    circleEcharts,
    _statisticsChart,
    polygonChart,
};
